import { FirebaseError } from '@firebase/util';
import { notification } from 'antd';
import { errDescGeneral, errMsgGeneral, errMsgWithCode } from '../../utils/helpers/errorTexts';

export const notifyFirebaseError = (error: unknown) =>
  notification.error({
    message: errMsgGeneral,
    description:error instanceof FirebaseError ?  errMsgWithCode(error.code) : errDescGeneral,
  });
